import React, { useMemo } from 'react';
import { map } from 'lodash-es';
import { RadioBoxGroup } from '@dev/ee-components';
import { RadioWrapper } from '../../styles';
import { RadioTaskSelectProps } from '../../types';

export const RadioTaskSelect = (props: RadioTaskSelectProps): JSX.Element => {
    const { steps, selectedStepsVariantValue, handleSetSelectedStepsVariant, title } = props;

    const radios = useMemo(
        () =>
            map(steps, (step) => ({
                id: step.id,
                label: step.title,
                value: step.id,
                disableSentenceCase: true,
            })),
        [steps]
    );

    return (
        <RadioWrapper>
            <RadioBoxGroup
                value={selectedStepsVariantValue}
                radioId={title}
                radioName={title}
                radios={radios}
                onChange={(e) => handleSetSelectedStepsVariant(e.target.value)}
                gridProps={{ sm: 6, md: 6 }}
            />
        </RadioWrapper>
    );
};
